import {VoidFunc} from "types/types";
import {observer} from "mobx-react";
import * as React from "react";
import {observable} from "mobx";
import * as theme from 'theme.js';
import {handleSpacePressed} from "utils";

interface IRadioQuestionOption_Props {
  index: number;
  selectedIndex: number;
  onQuestionAnswered: (index: number, callback: VoidFunc) => void;
  onClearAnswerFeedback: ()=>void;
  answerLocked:boolean;
  correctAnswerIsSelected:boolean;
  radioOptionName:string;
}

@observer
export class RadioQuestionOption extends React.Component<IRadioQuestionOption_Props> {
  @observable wrong: boolean = false;

  handleClick = (e) => {
    if(!this.props.answerLocked) {
      this.props.onQuestionAnswered(this.props.index, this.wrongAnswerCallback);
    }
  }

  wrongAnswerCallback = () => {
    this.wrong = true;
    setTimeout(this.clearWrongAnswer, 10000);
  }

  clearWrongAnswer = () => {
    this.wrong = false;
    this.props.onClearAnswerFeedback();
  }

  render() {

    let error = "";
    let questionStyle: any = {};
    let circleStyle: any = {
      borderColor: theme.GreenAA,
    };

    if(this.props.correctAnswerIsSelected) {
      if(this.props.index === this.props.selectedIndex) {
        circleStyle.background = theme.GreenAA;
      } else if(this.props.answerLocked) {
        circleStyle.borderColor = "#999999";
      }
    } else {
      if (this.wrong) {
        error = "Try again";
        circleStyle.borderColor = "#ca0219";
        circleStyle.backgroundColor = "#ca0219";
        questionStyle.textDecoration = "line-through";
      } else {
        circleStyle.borderColor = theme.GreenAA;
      }
    }

    return (
      <div className="option">
        <label>
          <input
            checked={this.props.index === this.props.selectedIndex}
            type={"radio"}
            name={this.props.radioOptionName}
            onClick={this.handleClick}
            disabled={this.props.answerLocked}
            value={this.props.index}
          />
          <div className="question" style={questionStyle}>{this.props.children}</div>
          <div className="error">{error}</div>
        </label>
      </div>
    )
  }
}


